import * as Dialog from '@radix-ui/react-dialog'
import AppIcon from '../icons/AppIcon'
import { cx } from '../util/cx'
import Button from './Button'
import styles from './Modal.module.css'

interface ModalProps {
  open: boolean
  onClose: () => void
  title?: string
  children: React.ReactNode
  footer?: React.ReactNode
  fullScreen?: boolean
  titleAlign?: 'center' | 'left'
}

export default function Modal({
  open,
  onClose,
  title,
  children,
  footer,
  fullScreen,
  titleAlign = 'center',
}: ModalProps) {
  return (
    <Dialog.Root open={open} onOpenChange={(next) => !next && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay
          className={cx(styles.backdrop, fullScreen && styles.fullscreen)}
        />
        <Dialog.Content
          className={cx(styles.panel, fullScreen && styles.fullscreenPanel)}
          aria-describedby={undefined}
        >
          {(title || !fullScreen) && (
            <div className={styles.header}>
              {title ? (
                <Dialog.Title
                  className={cx(styles.title, titleAlign === 'left' && styles.titleLeft)}
                >
                  {title}
                </Dialog.Title>
              ) : (
                <Dialog.Title className={styles.srOnly}>Dialog</Dialog.Title>
              )}
              <Dialog.Close type='button' className={styles.close} aria-label='Close'>
                <AppIcon icon='mdi:close' size={20} />
              </Dialog.Close>
            </div>
          )}
          {!title && fullScreen && (
            <Dialog.Title className={styles.srOnly}>Dialog</Dialog.Title>
          )}
          <div className={styles.body}>{children}</div>
          {footer && <div className={styles.footer}>{footer}</div>}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

interface ConfirmFooterProps {
  onCancel: () => void
  onConfirm: () => void
  confirmLabel: string
  cancelLabel?: string
  danger?: boolean
}

export function ConfirmFooter({
  onCancel,
  onConfirm,
  confirmLabel,
  cancelLabel = 'Cancel',
  danger,
}: ConfirmFooterProps) {
  return (
    <>
      <Button variant='ghost' onClick={onCancel}>
        {cancelLabel}
      </Button>
      <Button variant={danger ? 'primary' : 'blue'} onClick={onConfirm}>
        {confirmLabel}
      </Button>
    </>
  )
}
